// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiumBannerLandingPage-module__premiumBannerLandingPage--LR7_zyqb0f{margin-bottom:var(--pp-spacing-xl)}`, "",{"version":3,"sources":["webpack://./../../packages/loyalty-program-ui/src/components/landing-page/PremiumBannerLandingPage/PremiumBannerLandingPage.module.css"],"names":[],"mappings":"AAAA,uEACI,kCACJ","sourcesContent":[".premiumBannerLandingPage {\n    margin-bottom: var(--pp-spacing-xl);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"premiumBannerLandingPage": `PremiumBannerLandingPage-module__premiumBannerLandingPage--LR7_zyqb0f`
};
export default ___CSS_LOADER_EXPORT___;
